function millisecondsToMinutesAndSeconds(
  milliseconds: number,
  includeSign = false
): string {
  const sign = includeSign && milliseconds > 0 ? '+' : '';
  const totalSeconds = Math.floor(milliseconds / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds - totalMinutes * 60;

  if (totalMinutes < 60) {
    return `${sign}${totalMinutes}:${
      seconds.toString().length === 1 ? '0' : ''
    }${seconds}`;
  }

  const totalHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes - totalHours * 60;

  return `${sign}${totalHours}:${
    minutes.toString().length === 1 ? '0' : ''
  }${minutes}:${seconds.toString().length === 1 ? '0' : ''}${seconds}`;
}

export default millisecondsToMinutesAndSeconds;
